import React from 'react';
import { Tooltip } from 'antd';
import { TableHeader, TableRowData, TableDisplayData, CustomTable } from './style';
import { formatAmount } from '../../utils/commonUtil';
import RecurringIcon from '../../assets/icons/recurring.svg';
import GaIcon from '../../assets/icons/grant-agreement.svg';
import PropTypes from "prop-types";

export default function PrintTable(props) {
	const { dataSource, columns, titleFn = false, grantHistoryPendingAlert = false, hasIcons = false,clsName = '' } = props;
	const getIcons = (tdata, colData, tertiaryIndex) => {
		return (
			<>
				{!tdata[colData.dataIndex] && tdata.isRecurring && (
					<TableDisplayData key={`table-data-${tertiaryIndex}`}>
						<Tooltip placement="bottomLeft" title="Recurring Grant Schedule">
							<img className="pointer" src={RecurringIcon} alt="RecurringIcon" />
						</Tooltip>
					</TableDisplayData>
				)}
				{!tdata[colData.dataIndex] && tdata.grantAgreement && (
					<TableDisplayData key={`table-data-${tertiaryIndex}`}>
						<Tooltip placement="bottomLeft" title="Grant Agreement">
							<img className="pointer" src={GaIcon} alt="GaIcon" />
						</Tooltip>
					</TableDisplayData>
				)}
				{!tdata[colData.dataIndex] && !tdata.isRecurring && !tdata.grantAgreement && (
					<TableDisplayData key={`table-data-${tertiaryIndex}`}> </TableDisplayData>
				)}
			</>
		);
	};
	const createTableData = (tdata, colData, tertiaryIndex) => {
		return <TableDisplayData key={`table-data-${tertiaryIndex}`}>{tdata[colData.dataIndex]}</TableDisplayData>;
	};
	// This Condition will generate a table for Grant History and Pending Grant Alert Table
	if (grantHistoryPendingAlert) {
		return (
			<CustomTable>
				<TableHeader key={`table-head`}>
					{columns &&
						columns.map((thead, primaryIndex) => {
							return <td key={`table-head-${primaryIndex}`}>{thead.title}</td>;
						})}
				</TableHeader>
				{dataSource &&
					dataSource.map((tdata, secondaryIndex) => {
						return (
							<TableRowData key={`table-row-${secondaryIndex}`}>
								{columns &&
									columns.map((colData, tertiaryIndex) => {
										if (tertiaryIndex === 0) {
											return getIcons(tdata, colData, tertiaryIndex);
										} else {
											if (colData.title !== '') {
												if (colData.title === 'Recognition') {
													return (
														<TableDisplayData key={`table-data-${tertiaryIndex}`}>
															{tdata[colData.dataIndex].type}
														</TableDisplayData>
													);
												}
												if (colData.title === 'Amount') {
													return (
														<TableDisplayData key={`table-data-${tertiaryIndex}`}>
															{formatAmount(tdata[colData.dataIndex])}
														</TableDisplayData>
													);
												}
												return createTableData(tdata, colData, tertiaryIndex);
											}
										}
									})}
							</TableRowData>
						);
					})}
			</CustomTable>
		);
	}
	//Else this will generate a table for rest others
	return (
		<CustomTable>
			<TableHeader className= { clsName ? clsName : ''} key={`table-head`}>
				{columns &&
					columns.map((thead, primaryIndex) => {
						return <td key={`table-head-${primaryIndex}`}>{titleFn ? thead.title() : thead.title}</td>;
					})}
			</TableHeader>
			{dataSource && 
				dataSource.map((tdata, secondaryIndex) => {
					return (
						<TableRowData key={`table-row-${secondaryIndex}`}>
							{columns &&
								columns.map((colData, tertiaryIndex) => {
									return hasIcons && colData.dataIndex === 'isRecurring'
										? tdata[colData.dataIndex] && ( // This Condition is for Charities Recently Supported
												<TableDisplayData key={`table-data-${tertiaryIndex}`}>
													<img className="pointer" src={RecurringIcon} alt="RecurringIcon" />
												</TableDisplayData>
										  )
										: createTableData(tdata, colData, tertiaryIndex);
								})}
						</TableRowData>
					);
				})}
		</CustomTable>
	);
}

PrintTable.propTypes = {
  dataSource: PropTypes.array,
  columns: PropTypes.array,
  grantHistoryPendingAlert: PropTypes.bool,
  hasIcons: PropTypes.bool,
  titleFn: PropTypes.bool,
  width: PropTypes.number
}
